import React from 'react'
import { HeroCarousel } from '@/components/ui/hero-carousel'

const Hero = () => {
  return (
    <section id="home" className="relative">
      <HeroCarousel />
    </section>
  )
}

export default Hero
